import React from 'react';
import PropTypes from 'prop-types';

import analytics from '../../../modules/analytics';

import ShortSubscriptionBanners from './ShortSubscriptionBanners';

import ShortSubscriptionBanner from './ShortSubscriptionBanner';
import { SubscriptionBannerState } from '../../../modules/provider/Subscription';

/**
 * Represents a short subscription banner message for a pro,
 * rendered within the daily, calendar, and client tabs.
 */
export default class ShortSubscriptionBannerContainer extends React.PureComponent {
  static propTypes = {
    providerId: PropTypes.string.isRequired,
    bannerSource: PropTypes.string.isRequired,
    onOpen: PropTypes.func,
  };

  static defaultProps = {
    onOpen: () => {},
  };

  state = {
    banner: null,
  };

  isMounted = false;

  componentDidMount() {
    this.isMounted = true;
    // Retrieve data on our current subscription and provider
    SubscriptionBannerState.fetch(this.props.providerId, this.props.bannerSource)
      .then(subBannerState => {
        subBannerState.calculate().then(subBannerStateValue => {
          // Calculate subscription banners (Will be a new instance of EarlyTrialBanner,
          // LateTrialBanner, TrialExpiredBanner, GracePeriodBanner, CanceledAndNotExpiredBanner,
          // PendingPaymentsVerificationBanner)
          if (subBannerStateValue) {
            const banner = new ShortSubscriptionBanners[subBannerStateValue](
              subBannerState.subscription,
              this.props.bannerSource,
            );
            if (this.isMounted) {
              this.setState({ banner });
            }
          }

          // Run the onOpen callback if we have a banner
          if (this.state.banner) {
            analytics.track(`pro_${this.state.banner.tracking_key}_banner_viewed`);
            this.props.onOpen();
          }
        });
      });
  }

  componentWillUnmount() {
    this.isMounted = false;
  }

  render() {
    const { banner } = this.state;

    if (!banner) {
      return null;
    }

    return <ShortSubscriptionBanner banner={banner} />;
  }
}
